module.exports = __webpack_public_path__ + "img/ic_country_introduce.bd3b0dce.png";